import React from 'react';
import { Separator } from '../ui/separator';
import { BrandSection, QuickLinks, ContactSection, SocialLinks } from './FooterComponents';

export const Footer = () => {
  return (
    <footer className="relative border-t border-border/50">
      <div className="container px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <BrandSection />
          <QuickLinks />
          <ContactSection />
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Zappien. Todos los derechos reservados.
          </p>
          <SocialLinks />
        </div>
      </div>
    </footer>
  );
};
